import {getUtmTestParameters, parseGeneralParams, parseUtmParams} from "./UtmParser";
import queryString from "query-string";
import {assertEqual} from "../../unittests/UnitTestHelper";
import {parseProductParams} from "./ProdcutParamsParser";
import {parseLgParameters} from "./LgParamsParser";
import {calculatePricesAndCounts} from "./PriceCalculator";
import {currentLang, lgSetup, setCurrentLangExt} from "../../backend/LgSetup";
import {getProfile, saveProfile} from "../../logic_tmp/storage/LgProfile";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {calculateConcertFullInfoUrl, calculateFullInfoUrl} from "../../components/lg/widgets/common/LgHelper";
import i18next from "i18next";

export function testParametersParser() {
    let str = getUtmTestParameters() + "&productCode=RECORDING-ONEGIN-PART1"
    let res = {}
    let queryParams = queryString.parse(str)
    parseParameters(queryParams, res)
    assertEqual("1", res.skin)
    assertEqual("RECORDING-ONEGIN-PART1", res.productCode)

    str = getUtmTestParameters() + "&action=START"
    res = {}
    queryParams = queryString.parse(str)
    parseParameters(queryParams, res)
    assertEqual("1", res.skin)
    assertEqual(undefined, res.productCode)
    assertEqual("KOILIN_BELLACIAO", res.currentPath.lmKey)

}

export function parseUrl(res, str) {
    let queryParams = queryString.parse(str)
    parseParameters(queryParams, res)
    return res
}

export function testCalculateDefaultParamsCello() {
    /*
    let lng = currentLang
    setCurrentLangExt("ru")
    let params = {parentPath: "/cello202305"}
    let ret = {}
    parseParameters(params, ret)
    assertEqual("CELLO2023-UNKNOWN-UNKNOWN", ret.productCode)
    assertEqual("ESTONIA", ret.geoCode)
    setCurrentLangExt(lng)
    */
}


export function testCalculateDefaultParams() {
    let params = {parentPath: "/lrrh/memories"}
    let ret = {}
    parseParameters(params, ret)
    assertEqual(1, ret.skin)
    assertEqual("home", ret.utm_source)
    assertEqual("LRRH.Version1.TRAFFIC.Test1", ret.utm_campaign)
    assertEqual("HOT.ANY.RU.ANY.Ver1", ret.utm_medium)
    assertEqual("LRRH_MEMORIES-CHATGPTSTORY", ret.utm_content)
    assertEqual("LRRH_MEMORIES", ret.lmKey)
    assertEqual("CIRCLE", ret.action)
}

function calculateDefaultParamsProduct(params, ret) {
    let found = false
    Object.keys(lgSetup.products).map((productKey) => {
        if (found) return
        let product = lgSetup.products[productKey]
        if ((product["shortPageUrl"] !== undefined && product["shortPageUrl"].endsWith(params["parentPath"])) || (product["homepageUrl"] !== undefined && product["homepageUrl"].endsWith(params["parentPath"]))) {
            let concert = lgSetup.concerts[productKey.split("-")[0]]
            if (concert.region !== undefined)
                ret.geoCode = concert.region
            params["skin"] = 1
            params["productCode"] = productKey  // Используем найденный productCode напрямую
            if (params["lng"] === undefined)
                params["lng"] = "ru"
            found = true
        }
    })
}

function calculateDefaultParams(params, ret) {
    Object.keys(lgSetup.lms).map((lmKey) => {
        let lm = lgSetup.lms[lmKey]
        let lmUrl = lm["lmUrl"]
        if (lmUrl.endsWith(params["parentPath"])) {
            Object.keys(lgSetup.circles).map((circleKey) => {
                    let circle = lgSetup.circles[circleKey]
                    Object.keys(circle.lms).map((lmKey1) => {
                        let lm1 = circle.lms[lmKey1]
                        if (lmKey1 === lmKey) {
                            Object.keys(lgSetup.cmps).map((cmpKey) => {
                                    let cmp = lgSetup.cmps[cmpKey]
                                    if (cmp.circles !== undefined && cmp.circles !== null)
                                        Object.keys(cmp.circles).map((circleKey) => {
                                                params["skin"] = 1
                                                params["utm_source"] = "home"
                                                params["utm_campaign"] = cmpKey + ".Version1.TRAFFIC.Test1"
                                                params["utm_medium"] = "HOT." + Object.keys(cmp.regions)[0] + ".RU.ANY.Ver1"
                                                params["utm_content"] = Object.keys(lm1)[0]
                                                params["utm_brand"] = "brand"
                                                params["action"] = "CIRCLE"
                                                params["lmKey"] = lmKey
                                                if (params["lng"] === undefined)
                                                    params["lng"] = "ru"
                                            }
                                        )
                                }
                            )
                        }
                    })
                }
            )
        }
    })
}

export function parseParameters(params, ret) {
    let defaultInt = params["productCode"] === undefined && params["action"] === undefined
    if (defaultInt) {
        calculateDefaultParams(params, ret)
        if (params["action"] === undefined)
            calculateDefaultParamsProduct(params, ret)
    }
    let skipUtm = false
    if (params["utm_campaign"] === undefined || params["utm_campaign"] === null)
        skipUtm = true
    else {
        if (params["utm_campaign"].trim().length === 0 )
            skipUtm = true
        if (params["utm_campaign"].includes("{{"))
            skipUtm = true
        if (params["utm_campaign"].includes("unknown"))
            skipUtm = true
        if (params["utm_campaign"].includes("Invitation"))
            skipUtm = true
    }
    if (!skipUtm)
        parseUtmParams(params, ret)
    parseGeneralParams(params, ret)
    if (params["productCode"] !== undefined) {
        parseProductParams(params, ret)
        calculatePricesAndCounts(ret, ret.product)
    }
    if (params["action"] !== undefined)
        parseLgParameters(params, ret)
    if (ret.lmKey === undefined && ret.currentPath !== undefined) {
        ret.lmKey = ret.currentPath.lmKey
    }
    let profile = getProfile()
    if (defaultInt && (profile.firstEntryPath === undefined || (profile.firstEntryPath.circleKey === undefined || profile.firstEntryPath.lmKey === undefined || profile.firstEntryPath.adKey === undefined))) {
        getProfile().firstEntryPath = appdata.currentPath
        saveProfile()
    }
}

